const emails = [
  "gmail",
  "outlook",
  "aol",
  "yahoo",
  "mailinator",
  "hotmail",
  "msn",
  "email.msn",
  "passport",
  "live",
  "proton",
  "protonmail",
  "zoho",
  "zohomail",
  "icloud",
  "gmx",
  "tutanota",
  "criptext",
  "glalen",
  "jucatyo",
  "mainmile",
  "theeyeoftruth",
  "beaconmessenger",
  "Iamasticots",
  "gufum",
  "tutuapp.bid",
  "clout.wiki",
  "lyft.live",
  "yogrow.co",
  "afia.pro",
  "socam.me",
  "nllessons",
  "sharklasers",
  "startmail",
  "deercreeks",
  "cazlp",
  "wemel",
  "matra",
  "mywrld",
  "maildrop.cc",
  "nicoric"
];

export default emails;
